import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import LandingPage     from './pages/LandingPage';
import EmployerLanding from './pages/employer/EmployerLanding';
import WorkerStep1     from './pages/worker/WorkerStep1';
import WorkerStep2     from './pages/worker/WorkerStep2';
import WorkerStep3     from './pages/worker/WorkerStep3';
import WorkerStep4     from './pages/worker/WorkerStep4';
import WorkerStep5     from './pages/worker/WorkerStep5';
import WorkerDashboard    from './pages/worker/WorkerDashboard';
import EmployerDashboard from './pages/employer/EmployerDashboard';
import LoginPage              from './pages/auth/LoginPage';
import ResetPasswordPage      from './pages/auth/ResetPasswordPage';
import AuthCallback           from './pages/auth/AuthCallback';
import EmployerAuthCallback   from './pages/auth/EmployerAuthCallback';
import EmployerStep1          from './pages/employer/EmployerStep1';
import EmployerStep2          from './pages/employer/EmployerStep2';
import EmployerJoin           from './pages/employer/EmployerJoin';
import UnionJoin              from './pages/union/UnionJoin';
import PostJob                from './pages/employer/PostJob';
import EditJob                from './pages/employer/EditJob';
import EmployerPricing        from './pages/employer/EmployerPricing';
import WorkerProfile          from './pages/worker/WorkerProfile';
import CompanyProfile         from './pages/employer/CompanyProfile';
import ProtectedRoute         from './components/ProtectedRoute';
import AdminLogin             from './pages/admin/AdminLogin';
import AdminSignup            from './pages/admin/AdminSignup';
import AdminDashboard         from './pages/admin/AdminDashboard';
import TradesPage             from './pages/TradesPage';
import InterviewPage          from './pages/InterviewPage';
import CheckInPage            from './pages/CheckInPage';
import UnionPage              from './pages/UnionPage';
import UnionProfile           from './pages/unions/UnionProfile';
import UnionStep1             from './pages/union/UnionStep1';
import UnionStep2             from './pages/union/UnionStep2';
import UnionDashboard         from './pages/union/UnionDashboard';
import OrganizationJoin       from './pages/organization/OrganizationJoin';
import OrganizationLogin      from './pages/organization/OrganizationLogin';
import OrganizationDashboard  from './pages/organization/OrganizationDashboard';
import PublicResources        from './pages/PublicResources';
import UnionWages             from './pages/UnionWages';
import PrivacyPolicyPage         from './pages/legal/PrivacyPolicyPage';
import TermsAndConditionsPage    from './pages/legal/TermsAndConditionsPage';
import DisclaimerPage            from './pages/legal/DisclaimerPage';
import AcceptableUsePolicyPage   from './pages/legal/AcceptableUsePolicyPage';
import AccessibilityStatementPage from './pages/legal/AccessibilityStatementPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"                      element={<LandingPage />} />
        <Route path="/employers"             element={<EmployerLanding />} />
        <Route path="/trades"               element={<TradesPage />} />
        <Route path="/resources"            element={<PublicResources />} />
        <Route path="/union-wages"          element={<UnionWages />} />
        <Route path="/union"                element={<UnionPage />} />
        <Route path="/unions/:slug"          element={<UnionProfile />} />
        <Route path="/union/signup/step1"    element={<UnionStep1 />} />
        <Route path="/union/signup/step2"    element={<UnionStep2 />} />
        <Route path="/union/join"            element={<UnionJoin />} />
        <Route path="/union/dashboard"       element={<ProtectedRoute><UnionDashboard /></ProtectedRoute>} />
        <Route path="/organization/join"      element={<OrganizationJoin />} />
        <Route path="/organization/login"     element={<OrganizationLogin />} />
        <Route path="/organization/dashboard" element={<ProtectedRoute><OrganizationDashboard /></ProtectedRoute>} />
        <Route path="/worker/signup"         element={<WorkerStep1 />} />
        <Route path="/worker/signup/personal" element={<WorkerStep2 />} />
        <Route path="/worker/signup/trade"   element={<WorkerStep3 />} />
        <Route path="/worker/signup/resume"  element={<WorkerStep4 />} />
        <Route path="/worker/signup/verify"  element={<WorkerStep5 />} />
        <Route path="/worker/dashboard"      element={<ProtectedRoute><WorkerDashboard /></ProtectedRoute>} />
        <Route path="/employer/dashboard"    element={<ProtectedRoute><EmployerDashboard /></ProtectedRoute>} />
        {/* Legacy standalone prototype removed -- the real, data-backed School Finder lives
            as a tab inside WorkerDashboard; this keeps old bookmarks/links working. */}
        <Route path="/worker/schools"        element={<Navigate to="/worker/dashboard?tab=School%20Finder" replace />} />
        <Route path="/employer/signup"         element={<EmployerStep1 />} />
        <Route path="/employer/signup/company" element={<EmployerStep2 />} />
        <Route path="/employer/join"           element={<EmployerJoin />} />
        <Route path="/auth/employer/callback" element={<EmployerAuthCallback />} />
        <Route path="/employer/post-job"          element={<PostJob />} />
        <Route path="/employer/edit-job/:id"      element={<EditJob />} />
        <Route path="/employer/pricing"           element={<EmployerPricing />} />
        <Route path="/worker/profile/:workerId"   element={<WorkerProfile />} />
        <Route path="/company/:employerId"        element={<CompanyProfile />} />
        <Route path="/login"                 element={<LoginPage />} />
        <Route path="/reset-password"        element={<ResetPasswordPage />} />
        <Route path="/auth/callback"         element={<AuthCallback />} />
        <Route path="/admin"                 element={<AdminLogin />} />
        <Route path="/admin/signup"          element={<AdminSignup />} />
        <Route path="/admin/dashboard"       element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/interview"             element={<InterviewPage />} />
        <Route path="/checkin"               element={<CheckInPage />} />
        <Route path="/privacy-policy"           element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions"     element={<TermsAndConditionsPage />} />
        <Route path="/disclaimer"               element={<DisclaimerPage />} />
        <Route path="/acceptable-use-policy"    element={<AcceptableUsePolicyPage />} />
        <Route path="/accessibility-statement"  element={<AccessibilityStatementPage />} />
        <Route path="*"                      element={<Navigate to="/" replace />} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
